import Ax from './axios';
import config from '../const/config';

const API = config.SERVICE_API;

/**
 * 获取用户押金套餐等通用信息
 * @param {*} data
 */
export function getCommon(data) {
  return Ax.post(API, {
    ...data,
    action: 'switchpower.user.common',
  }).then((r) => r.data);
}

// 分期套餐支付详情
export function installmentDetails(data) {
  return Ax.post(API, {
    ...data,
    action: 'switchpower.user.installmentDetails',
  }).then((r) => r.data);
}

// 套餐卷兑换
export function deductionCardUse(data) {
  return Ax.post(API, {
    ...data,
    action: 'switchpower.deduction.card.use',
  }).then((r) => r.data);
}

// 获取用户是否即将到期套餐信息
export function getReturnBatteryHint(data) {
  return Ax.post(API, {
    ...data,
    action: 'switchpower.user.getReturnBatteryHint',
  }).then((r) => r.data);
}
